import React from "react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  RouterModalManager,
} from "src/components/Modal";
import { IframeLoader } from "src/components/IframeLoader";
import { TNC_FILES } from "src/constants";

type Props = {
  hash: string;
};

export const PassportTnCModal = ({ hash }: Props) => {
  return (
    <RouterModalManager hash={hash} scrollable fullScreen>
      <Modal>
        <ModalHeader />
        <ModalContent>
          <IframeLoader src={TNC_FILES.MIDTRANS} />
        </ModalContent>
      </Modal>
    </RouterModalManager>
  );
};
